export default __webpack_public_path__ + "static/media/sticker-s.0f19bf7b.png";